import React from 'react';
import coachImage from '../../assets/image/image.png';

const AboutSection = () => {
  const stats = [
    { number: "25+", label: "Years Experience" },
    { number: "₹43Cr+", label: "Recovered" },
    { number: "104+", label: "Seminars" },
    { number: "18,000+", label: "Business Owners Trained" }
  ];

  return (
    <section className="relative py-24 bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium mb-4">
            Meet Your Instructor
          </span>
          <h2 className="text-4xl sm:text-5xl font-black text-white">
            Rushneek Singh
          </h2>
          <p className="text-xl text-amber-400 mt-2">India's No. 1 B2B Payment Recovery Coach</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <div className="relative group order-1 lg:order-1">
            {/* Decorative Elements */}
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-500/20 to-orange-500/20 rounded-3xl blur-2xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
            
            {/* Main Image Container */}
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-orange-600 rounded-3xl"></div>
              <div className="relative bg-gray-900 rounded-3xl p-2">
                <img 
                  src={coachImage} 
                  alt="Rushneek Singh" 
                  className="w-full h-auto rounded-2xl object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
                />
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-gray-800 to-gray-900 backdrop-blur-sm rounded-2xl p-4 border border-amber-500/30 shadow-xl hidden sm:block">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                  </svg>
                </div>
                <div>
                  <p className="text-amber-400 font-bold">8000+</p>
                  <p className="text-gray-400 text-sm">Committed Students</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="order-2 lg:order-2">
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p className="text-lg">
                <span className="text-amber-400 font-semibold">Rushneek Singh</span> is India's leading Payment Recovery expert with over <span className="text-white font-semibold">25 years of experience</span> in payment recovery. As a seasoned expert, he has successfully assisted his mentees in recovering more than <span className="text-amber-400 font-bold">₹43Cr+ Crores</span> from the Indian markets in the past 36 months.
              </p>
              
              <p className="text-lg">
                He has conducted over <span className="text-white font-semibold">104 seminars and webinars</span>, providing invaluable guidance to more than <span className="text-amber-400 font-bold">18,000 business owners</span> on creating world-class payment recovery systems for their businesses. His community includes <span className="text-white font-semibold">8000+ committed students</span> who have been benefited from his extensive knowledge and experience.
              </p>
              
              <p className="text-lg">
                He is also the author of the E-book <span className="text-amber-400 font-semibold">"23 Principles To Get Payments on Time - Always"</span>, which offers practical advice and strategies for timely payment recovery. Additionally, Rushneek has introduced a comprehensive <span className="text-white font-semibold">10-hour</span> live recorded training program designed to eliminate late payments and ensure financial stability for businesses.
              </p>
              
              <p className="text-lg italic text-amber-400/80">
                "Join Rushneek on a transformative journey to secure timely payments and achieve lasting business prosperity."
              </p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
              {stats.map((stat, index) => (
                <div 
                  key={index}
                  className="text-center p-4 bg-gray-800/30 rounded-2xl border border-gray-700/30 hover:border-amber-500/30 transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="text-2xl sm:text-3xl font-black bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent mb-1">
                    {stat.number}
                  </div>
                  <div className="text-xs text-gray-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
